import { Link, Outlet } from 'react-router';
import { BookOpen } from 'lucide-react';
import { HELP_INDEX_PATH } from '@/modules/help/constants/help-routes';

/**
 * Public shell of the help area. It renders outside the panel, so it carries
 * no session guard and no panel chrome.
 */
export function HelpLayout() {
  return (
    <div className="flex h-dvh flex-col bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-6">
          <Link
            to={HELP_INDEX_PATH}
            className="flex items-center gap-2 text-lg font-semibold text-slate-900"
          >
            <BookOpen className="h-5 w-5 text-slate-500" strokeWidth={1.5} aria-hidden="true" />
            Ayuda
          </Link>
          {/* Full page load: the panel is a different surface and boots from scratch. */}
          <a
            href="/dashboard"
            className="text-sm font-medium text-slate-600 hover:text-slate-900 hover:underline"
          >
            Ir a la aplicación
          </a>
        </div>
      </header>
      {/*
        The global scroll lock (html, body overflow hidden) leaves this branch
        without a scroller, so the shell carries its own inner vertical scroll.
      */}
      <main className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
